// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content .step {
  position: absolute;
  height: -moz-fit-content;
  height: fit-content;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
ion-content .step.isCutting {
  justify-content: center;
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
  flex-direction: column;
}
ion-content .step.isCutting .cropper-wrapper {
  padding: 10px;
  max-height: 85%;
}
ion-content .step .img {
  display: block;
  box-sizing: content-box;
  border-radius: 50%;
  padding: 0px;
  flex-direction: column;
  width: 65%;
  margin: 40px auto 20px;
}
ion-content .step .img.photo {
  border-radius: 5px;
}
ion-content .step .body {
  text-align: center;
  padding: 0 40px;
  height: 100%;
  flex-direction: column;
  display: flex;
  justify-content: start;
}
ion-content .step .body .info-paragraph {
  font-size: 16px;
  margin-top: 0;
}
ion-content .step .body .upload-button {
  margin: 12px 40px 80px;
}
ion-content .step .body .info-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 40px;
}
ion-content .step .body .link-volver {
  font-size: 18px;
  text-decoration: none;
}
ion-content .step .bodyCut {
  text-align: center;
  padding: 20px 40px;
  flex-direction: column-reverse;
  display: flex;
  justify-content: space-between;
}

image-cropper {
  --cropper-overlay-color: var(--background);
}`, "",{"version":3,"sources":["webpack://./src/app/components/experiences/experience-record-visit/experience-record-visit.page.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AADR;AAKQ;EACI,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AAHZ;AAKY;EACI,aAAA;EACA,eAAA;AAHhB;AAOQ;EACI,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,sBAAA;AALZ;AAOY;EACI,kBAAA;AALhB;AASQ;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AAPZ;AASY;EACI,eAAA;EACA,aAAA;AAPhB;AAUY;EACI,sBAAA;AARhB;AAWY;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AAThB;AAYY;EACI,eAAA;EACA,qBAAA;AAVhB;AAeQ;EACI,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,8BAAA;AAbZ;;AAmBA;EACI,0CAAA;AAhBJ","sourcesContent":["ion-content {\r\n\r\n    .step {\r\n        position: absolute;\r\n        height: fit-content;\r\n        top: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n        margin: auto;\r\n\r\n\r\n\r\n        &.isCutting {\r\n            justify-content: center;\r\n            display: flex;\r\n            position: relative;\r\n            height: 100%;\r\n            width: 100%;\r\n            flex-direction: column;\r\n\r\n            .cropper-wrapper {\r\n                padding: 10px;\r\n                max-height: 85%;\r\n            }\r\n        }\r\n\r\n        .img {\r\n            display: block;\r\n            box-sizing: content-box;\r\n            border-radius: 50%;\r\n            padding: 0px;\r\n            flex-direction: column;\r\n            width: 65%;\r\n            margin: 40px auto 20px;\r\n\r\n            &.photo {\r\n                border-radius: 5px;\r\n            }\r\n        }\r\n\r\n        .body {\r\n            text-align: center;\r\n            padding: 0 40px;\r\n            height: 100%;\r\n            flex-direction: column;\r\n            display: flex;\r\n            justify-content: start;\r\n\r\n            .info-paragraph {\r\n                font-size: 16px;\r\n                margin-top: 0;\r\n            }\r\n\r\n            .upload-button {\r\n                margin: 12px 40px 80px;\r\n            }\r\n\r\n            .info-title {\r\n                font-size: 32px;\r\n                font-weight: bold;\r\n                margin-bottom: 40px;\r\n            }\r\n\r\n            .link-volver {\r\n                font-size: 18px;\r\n                text-decoration: none;\r\n            }\r\n\r\n        }\r\n\r\n        .bodyCut {\r\n            text-align: center;\r\n            padding: 20px 40px;\r\n            flex-direction: column-reverse;\r\n            display: flex;\r\n            justify-content: space-between;\r\n        }\r\n    }\r\n\r\n}\r\n\r\nimage-cropper {\r\n    --cropper-overlay-color: var(--background);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
